import { remove, findIndex, propEq, curry } from 'ramda';

export const removeById = curry((id: string, list: any[]) => {
  const index = findIndex(propEq('id', id), list);
  return index === -1 ? list : remove(index, 1, list);
});
